module.exports = "/_next/static/images/apple-touch-icon-152-be9e2183c4ebf6130e97905830574fcf.png";